import { render, staticRenderFns } from "./SoftphoneHeaderWidget.vue?vue&type=template&id=3bc23014&scoped=true"
import script from "./SoftphoneHeaderWidget.vue?vue&type=script&lang=js"
export * from "./SoftphoneHeaderWidget.vue?vue&type=script&lang=js"
import style0 from "./SoftphoneHeaderWidget.vue?vue&type=style&index=0&id=3bc23014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc23014",
  null
  
)

export default component.exports